import { useState } from 'react';
import ExploreUnifiedSearch from '../components/ExploreUnifiedSearch';
import '../styles/Explore.css';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useSearchParams } from 'react-router-dom';
import { EXPLORE_SECTIONS } from '../config/exploreSections';

const filters = [{ id: 'all', label: 'All' }, ...EXPLORE_SECTIONS];

const Explore = () => {
  const { currentUser, loading } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState('');
  const requested = searchParams.get('type');
  const activeFilter = filters.some((filter) => filter.id === requested) ? requested : 'all';

  const setActiveFilter = (id) => {
    setSearchParams(id === 'all' ? {} : { type: id });
  };

  if (!loading && !currentUser) {
    return <Navigate to="/signup" replace />;
  }

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  return (
    <div className="explore-page">
      <div className="explore-header">
        <h1>Explore</h1>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search artworks, galleries, exhibitions, or articles..."
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
          />
          {searchQuery && (
            <button 
              onClick={clearSearch}
              className="clear-search"
              aria-label="Clear search"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          )}
          <svg
            className="search-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
        <div className="filter-tabs">
          {filters.map(filter => (
            <button
              key={filter.id}
              className={`filter-tab ${activeFilter === filter.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>
      <ExploreUnifiedSearch 
        searchQuery={searchQuery}
        filter={activeFilter}
      />
    </div>
  );
};

export default Explore; 